import React from "react";
import Icon from "@icon-park/react/es/all";
import { Text, theme } from "@ifgengineering/component-library";
import {
  StartupCardContainer,
  StartupCardHeader,
  StartupCardLeft,
  StartupLogo,
  StartupCardDetails,
  DetailGroup,
  DetailItem,
} from "./styled";
import { EisFundStartup } from "./types";
import { TAX_BENEFIT_LABELS } from "./constants";
import EisFundInvestmentStatus from "./EisFundInvestmentStatus";

import noLogoImage from "@assets/cur8/img/no-logo-deal.png";

interface EisFundStartupCardProps {
  startup: EisFundStartup;
  onClick?: (startup: EisFundStartup) => void;
}

const formatCurrency = (amount: number, currency = "GBP"): string => {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

const EisFundStartupCard: React.FC<EisFundStartupCardProps> = ({
  startup,
  onClick,
}) => {
  const handleStartupClick = () => {
    if (onClick) {
      onClick(startup);
    } else if (startup.externalUrl) {
      window.open(startup.externalUrl, "_blank");
    }
  };

  return (
    <StartupCardContainer
      data-testid="eis-startup-card"
      onClick={handleStartupClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <StartupCardHeader>
        <StartupCardLeft>
          <StartupLogo
            src={startup.logoUrl || noLogoImage}
            alt={startup.name}
            onError={(e) => {
              e.currentTarget.src = noLogoImage;
            }}
          />
          <Text type="H14" color="SLATE800">
            {startup.name}
          </Text>
          {startup.externalUrl && (
            <Icon type="Share" fill={theme.colors.BLUE600} size={16} />
          )}
        </StartupCardLeft>
      </StartupCardHeader>

      <StartupCardDetails>
        <DetailGroup>
          <DetailItem>
            <Text type="P14" color="SLATE800">
              Amount Invested
            </Text>
            <Text type="H16" color="SLATE900">
              {formatCurrency(startup.amountInvested, startup.currency)}
            </Text>
          </DetailItem>
          <DetailItem>
            <Text type="P14" color="SLATE800">
              Tax Benefits
            </Text>
            <Text type="H16" color="SLATE900">
              {TAX_BENEFIT_LABELS[startup.taxBenefit]}
            </Text>
          </DetailItem>
        </DetailGroup>

        {startup.statusLabel && (
          <EisFundInvestmentStatus statusLabel={startup.statusLabel} />
        )}
      </StartupCardDetails>
    </StartupCardContainer>
  );
};

export default EisFundStartupCard;
